import "../styles/Certifications.css";

function Certifications(props) {
  return (
    <section id="certifications-parent-container">
      <h1>Certifications 🎗️</h1>
      <div id="certifications-container">
        <div
          data-iframe-width="150"
          data-iframe-height="250"
          data-share-badge-id="b2ade88c-3b77-45ed-b23e-bbcb28b628d2"
          data-share-badge-host="https://www.credly.com"
        ></div>
        <div
          data-iframe-width="150"
          data-iframe-height="250"
          data-share-badge-id="08cc8816-f424-440c-aea8-29ee249d43b9"
          data-share-badge-host="https://www.credly.com"
        ></div>
        <div
          data-iframe-width="150"
          data-iframe-height="250"
          data-share-badge-id="7342eb96-f225-46a8-8c13-a3d5f484e734"
          data-share-badge-host="https://www.credly.com"
        ></div>
      </div>
    </section>
  );
}

export default Certifications;
